// extracted by mini-css-extract-plugin
export default {"timeslotTime":"TimeReference_timeslotTime__XsrsO","timetable_times":"TimeReference_timetable_times__7s8H6"};